import React, {useState} from 'react';
import {TabPanel, TabView} from "primereact/tabview";

import AlertFan from "./AlertFan";
import Silences from "./Silences";

const AlertTabMain = ({topicTags, itemTags, hiddenTopicTags}) => {
    const [tab, setTab] = useState(0)

    const [tags, setTags] = useState<{ topics?: Array<string>, items?: Array<string> }>()

    return <TabView activeIndex={tab} onTabChange={(e) => setTab(e.index)}>
        <TabPanel header="Alerts">
            <AlertFan setTab={setTab} setTags={setTags} topicTags={topicTags} itemTags={itemTags} hiddenTopicTags={hiddenTopicTags}/>
        </TabPanel>
        <TabPanel header="Silences">
            <Silences setTab={setTab} tags={tags} setTags={setTags} />
        </TabPanel>
    </TabView>
};

export default AlertTabMain;